import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './HorizontalText.scss';

gsap.registerPlugin(ScrollTrigger);

const HorizontalText = () => {
    const wrapperRef = useRef(null);
    const textContainerRef = useRef(null);
    const text = "The containerAnimation property allows us to create ScrollTriggered animations within a container that's animated horizontally. It's like having nested ScrollTriggers!";

    useEffect(() => {
        // Add a small delay to ensure DOM is ready
        let rafId = requestAnimationFrame(() => {
            const ctx = gsap.context(() => {
                const wrapper = wrapperRef.current;
                const textContainer = textContainerRef.current;

                if (!wrapper || !textContainer) return;

                const chars = textContainer.querySelectorAll('.char');

                // Create the main horizontal scroll animation
                const scrollTween = gsap.to(textContainer, {
                    xPercent: -100,
                    ease: "none",
                    scrollTrigger: {
                        trigger: wrapper,
                        pin: true,
                        start: "center center",
                        end: "+=15000",
                        scrub: 0.5,
                    }
                });

                // Animate each character
                chars.forEach((char) => {
                    gsap.from(char, {
                        yPercent: gsap.utils.random(-200, 200),
                        rotation: gsap.utils.random(-20, 20),
                        ease: "back.out(1.2)",
                        scrollTrigger: {
                            trigger: char,
                            containerAnimation: scrollTween,
                            start: "left 100%",
                            end: "left 30%",
                            scrub: 1
                        }
                    });
                });
            }, wrapperRef);

            return () => {
                ctx.revert();
            };
        });

        // Cleanup
        return () => {
            if (rafId) cancelAnimationFrame(rafId);
        };
    }, []);

    // Split text into characters manually
    const renderText = () => {
        return text.split('').map((char, index) => (
            <span key={index} className="char">
                {char === ' ' ? '\u00A0' : char}
            </span>
        ));
    };

    return (
        <>
            <div style={{ height: '50vh', background: '#1a1a1a' }}></div>
            <section className="Horizontal" ref={wrapperRef}>
                <div className="container">
                    <h3 className="Horizontal__text heading-xl" ref={textContainerRef}>
                        {renderText()}
                    </h3>
                </div>
            </section>
            <div style={{ height: '50vh', background: '#1a1a1a' }}></div>
        </>
    );
};

export default HorizontalText;
